import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import HelpIcon from '../../../../../assets/icons/help.svg';
import {getCourseLabel} from '../../../../../utils/entity/course/getCourseLabel';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, course, invite, program} = contexts;

  const data: EventData = {};

  if (invite?.user_questionnaire_id) {
    data.avatar = actor?.avatar;
    data.avatarPlaceholder = actor?.name;

    data.title = i18n.t('notifications:invite_received.questionnaire.title', {
      coachName: invite?.coach?.name,
      questionnaireTitle: invite?.user_questionnaire?.title,
    });

    data.icon = HelpIcon;
    data.iconGradient = 'success';
  } else if (invite?.program_id) {
    data.avatar = program?.avatar;
    data.avatarPlaceholder = program?.title;

    data.subAvatar = invite?.coach?.coach_logo;
    data.subAvatarPlaceholder = invite?.coach?.coach_title || '';

    data.title = i18n.t('notifications:invite_received.program.title', {
      coachName: invite?.coach?.name,
      programTitle: program?.title,
    });

    data.message = invite?.message;
  } else if (invite?.course_id) {
    data.avatar = program?.avatar;
    data.avatarPlaceholder = program?.title;

    data.subAvatar = invite?.coach?.coach_logo;
    data.subAvatarPlaceholder = invite?.coach?.coach_title || '';

    const courseLabel = getCourseLabel(course);

    data.title = i18n.t('notifications:invite_received.course.title', {
      coachName: invite?.coach?.name,
      courseDates: courseLabel ? `(${courseLabel})` : '',
      courseTitle: program?.title,
    });
  } else {
    data.avatar = actor?.avatar;
    data.avatarPlaceholder = actor?.name;

    data.title = i18n.t('notifications:invite_received.practice.title', {
      coachName: actor?.name,
      practiceTitle: actor?.coach_title,
    });
  }

  return data;
};
